<template>
  <div id="footer">
    <div class="bottom">
      <div class="nav-bottom">
        <div class="container">
          <div class="rowText">
            <div class="col-xs-12 hidden-xs flex">
              <ul>
                <li>
                  <h4>Products</h4>
                </li>
                <li>
                  <a class="hand" @click="$router.push('/product2')"
                    >Intelligent Analysis System of Train Driver's Behavior</a
                  >
                </li>
                <li>
                  <a target="_blank" :href="product[1]"
                    >Automated AI Robot for EMU Maintenance</a
                  >
                </li>
                <li>
                  <a class="hand" @click="$router.push('/product1')"
                    >Automatic Detection System of Subway Tunnel Intrusion
                    Limit</a
                  >
                </li>
                <li>
                  <a target="_blank" :href="product[4]"
                    >Aviation Big Data Analysis System</a
                  >
                </li>
              </ul>
              <div class="dis-flex">
                <ul class="hand" @click="$router.push('/solution3')">
                  <li>
                    <h4>Solutions</h4>
                  </li>

                  <li><a>Computer Vision</a></li>
                  <li>
                    <a>Natural Language Processing</a>
                  </li>
                  <li>
                    <a>Speech Recognition</a>
                  </li>
                  <li><a>Machine Learning</a></li>
                  <li><a>Search Engine</a></li>
                </ul>
                <ul id="bottom-pills">
                  <li>
                    <h4>About Us</h4>
                  </li>
                  <li>
                    <a class="hand" @click="$router.push('/aboutus')"
                      >Company Profile</a
                    >
                  </li>
                  <li>
                    <a class="hand" @click="$router.push('/aboutus')"
                      >Qualifications</a
                    >
                  </li>
                  <li>
                    <a class="hand" @click="$router.push('/aboutus')"
                      >Company Culture</a
                    >
                  </li>
                </ul>
                <ul>
                  <li>
                    <h4>Join Us</h4>
                  </li>
                  <li><a target="_blank" :href="join1">Talent Concept</a></li>
                  <li><a target="_blank" :href="join2">Contact Us</a></li>
                </ul>
              </div>
            </div>

            <div class="right col-lg-3 text-center">
              <ul>
                <li>
                  <h4>WeChat Subscription</h4>
                </li>
                <li>
                  <img
                    src="../assets/img/home/公众号二维码.png?v=1.1"
                    alt="公众号二维码"
                    style="width: 80px"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="info-bottom">
      <p>Copyright @Shenzhen Beyebe Network Technology Co., Ltd.</p>
      <!-- <p>
        Value-added telecommunications business license: Guangdong B2-20110200
        <a href="http://beian.miit.gov.cn/" target="_blank"
          >Guangdong ICP No. 08129733</a
        >
        <a
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502000202"
          target="_blank"
          >Guangdong Public Network Security No. 44030502000202</a
        >
      </p> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      product: [
        "http://www.beyebe.com/solution/solution_detail.html?name=0",
        "http://www.beyebe.com/solution/solution_detail.html?name=2",
        "http://www.beyebe.com/solution/solution_detail.html?name=3",
        "http://www.beyebe.com/solution/solution_detail.html?name=4",
        "http://www.beyebe.com/solution/solution_detail.html?name=5"
      ],
      about: [
        "http://www.beyebe.com/about_us.html#adout_1",
        "http://www.beyebe.com/about_us.html#adout_2",
        "http://www.beyebe.com/about_us.html#adout_3"
      ],
      view: "http://www.beyebe.com/technical_service.html#computer-view?v=1.1",
      join1: "http://www.beyebe.com/join_us.html#join_1",
      join2: "http://www.beyebe.com/join_us.html#join_2"
    };
  }
};
</script>
<style scoped>
.hand {
  cursor: pointer;
}
#footer {
  width: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
/* 底部 */
.nav-bottom {
  background-color: #292b2d;
  padding: 60px 0;
}
.nav-bottom ul h4 {
  font-weight: 700;
}
.nav-bottom .rowText .flex {
  display: flex;
}
.nav-bottom .rowText a {
  opacity: 0.8;
  font-family: "NunitoSans-Regular" !important;
}
.nav-bottom .rowText ul {
  display: inline-block;
  padding: 0;
  vertical-align: top;
  box-sizing: border-box;
}
@media screen and (min-width: 768px) {
  .nav-bottom .rowText ul {
    margin: 0 64px 0 0;
  }
}
@media screen and (max-width: 767px) {
  .nav-bottom .rowText ul {
    margin: 0;
  }
}
.nav-bottom .rowText .right ul {
  height: auto;
}
.nav-bottom .rowText ul li img {
  margin: 0 auto;
}
.info-bottom {
  background-color: #000;
  padding: 12px 0;
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 18px;
}
.info-bottom p {
  margin: 0;
}
.info-bottom p a {
  color: #fff;
}
.bottom ul li {
  margin-top: 20px;
  list-style: none;
  font-size: 14px;
  color: #fff;
}
.bottom ul li:first-child {
  margin-top: 0;
}
.bottom ul li h4 {
  margin-top: 0;
  font-weight: 100;
  letter-spacing: 1px;
  font-size: 20px;
  color: white;
}
.bottom ul li a {
  color: #fff;
}
.dis-flex {
  display: flex;
}
.col-xs-12 {
  width: 75% !important;
  text-align: left;
}
.col-xs-12 li a {
  font-size: 14px;
}
@media screen and (max-width: 768px) {
  .nav-bottom .col-xs-12 li {
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue